function buildBusinessIdsQuery(ids: string[], excludeIds: boolean) {
  const operator = excludeIds ? '$nin' : '$in';

  return (ids.length ? ids : [''])
    .map((id, index) => `&query[business][id][${operator}][${index}]=${id}`)
    .join('&');
}
export default buildBusinessIdsQuery;
